import React from 'react';
import { Icon } from '../ds/components/Icon';

/**
 * pkt 14 (właściciel 2026-09-13): „Zakres kontroli" w CEEB (liczby przewodów) pusty albo zerowy —
 * kominiarz uzupełnia go ręcznie w CEEB, nocny import przepisuje i wykrzyknik znika. Źródło
 * prawdy: `flue_counts_missing` z listy (routes/pipelineQuery.js). Jeden znacznik dla listy
 * budynków i widoku budynku.
 */
// 2026-10-15 (Bronek): przy świeżo zaplanowanych budynkach trójkąt wisi do nocnego importu, który
// przepisuje liczby z OSTATNIEGO protokołu CEEB — tekst ma uspokajać, że to nie dotyczy protokołów w CEEB.
export const FLUE_WARNING_TEXT =
  'Brak liczby przewodów w tym przeglądzie — uzupełni się po nocnym imporcie z ostatniego protokołu CEEB; ' +
  'jeśli zostanie, wpisz „Zakres kontroli” w CEEB. Nie dotyczy istniejących protokołów.';

export function FlueWarningIcon({ testId, size = 16 }: { testId: string; size?: number }) {
  return (
    <span
      data-testid={testId}
      title={FLUE_WARNING_TEXT}
      aria-label={FLUE_WARNING_TEXT}
      style={{ display: 'inline-flex', color: 'var(--status-deny)' }}
    >
      <Icon name="triangle-alert" size={size} />
    </span>
  );
}
